import Image from 'next/image'

import { formatPermissionsExpiresAt } from '../../../lib/utils'
import { FixedBottomDrawerButton } from '../../FixedBottomDrawerButton'

type Props = {
  goBack: () => void
  permissionsExpiresAt?: string | null
}

const getAccessPeriodText = (permissionsExpiresAt?: string | null) =>
  permissionsExpiresAt
    ? `Доступ предоставляется до ${formatPermissionsExpiresAt(
        permissionsExpiresAt
      )}`
    : 'Доступ предоставляется на неограниченное время'

export const InviteCreationSucceedScreen = ({
  goBack,
  permissionsExpiresAt = null
}: Props) => (
  <div className="flex flex-1 flex-col items-center justify-between px-40 pb-[120px] md:px-24 xxs:px-16">
    <div className="flex flex-1 flex-col items-center justify-center gap-20 pb-80">
      <Image
        src="/images/shared/CheckMark.png"
        width={140}
        height={140}
        alt="blocked"
        className="rotate-12"
      />
      <p
        data-testid="invite-succeed-access-period"
        className="text-center text-grey-70 text-20 xxs:text-16"
      >
        {getAccessPeriodText(permissionsExpiresAt)}, но вы сможете закрыть
        доступ из своего профиля в любой момент. Приглашение будет доступно 3
        дня.
      </p>
    </div>
    <FixedBottomDrawerButton text="Понятно" onClick={goBack} />
  </div>
)
